<template>
	<div class="component_inner">
		<template v-if="this.validation_errors && this.validation_errors.billing_email && this.validation_errors.billing_email[0] == 'An account exists with this email address, please log in'">
			<p class="email_error">An account exists with the email address you entered. Please <a href="/login">log in</a> to continue. If you have forgotten your password you can <a href="/password/reset">reset it</a>.</p>
		</template>

		<template v-if="show_delivery">
			<h2 class="with_line">Delivery Details</h2>
			<div class="form_wrap postcode_lookup">
				<p>
					<label for="shipping_lookup_postcode">Enter your postcode to find your address</label>
					<input type="text" name="shipping_lookup_postcode" id="shipping_lookup_postcode" v-model="shipping_lookup_postcode">
					<button type="button" class="button primary" v-on:click="lookupAddress('shipping')">Find</button>
				</p>
				<p v-if="shipping_lookup_addresses != null">
					<b><i class="fas fa-arrow-alt-down"></i> Select your address from the list below <i class="fas fa-arrow-alt-down"></i></b>
					<span class="select_wrapper" >
						<select class="styled_select" v-model="selected_shipping_address">
							<option value="">Select an address</option>
							<option value="Not Listed">My address is not listed</option>
							<template v-for="(address, key) in shipping_lookup_addresses">
								<option v-bind:value="address">{{ formatAddress(address.formatted_address) }}</option>
							</template>
						</select>
					</span>
				</p>
			</div>

			<div class="form_wrap" v-show="(default_shipping_address != null && Object.keys(default_shipping_address).length > 0) || Object.keys(selected_shipping_address).length > 0 || show_delivery_edit || this.validation_errors">
				<p class="half">
					<label for="shipping_first_name" class="required">First Name</label>
					<input type="text" name="shipping_first_name" id="shipping_first_name" v-model="shipping_address.first_name">
					<span class="validation-error" v-if="this.validation_errors && this.validation_errors.shipping_first_name">{{ this.validation_errors.shipping_first_name[0] }}</span>
				</p>
				<p class="half">
					<label for="shipping_last_name" class="required">Last Name</label>
					<input type="text" name="shipping_last_name" id="shipping_last_name" v-model="shipping_address.last_name">
					<span class="validation-error" v-if="this.validation_errors && this.validation_errors.shipping_last_name">{{ this.validation_errors.shipping_last_name[0] }}</span>
				</p>
				
				<p v-if="!show_delivery_edit" class="address_details"><span v-html="formatted_shipping_address"></span><button v-on:click="showDeliveryEdit()">[edit]</button></p>

				<div class="form_style" v-show="show_delivery_edit">
					<p>
						<label for="shipping_address_1" class="required">Address</label>
						<input type="text" name="shipping_address_1" id="shipping_address_1" v-model="shipping_address.address_1" placeholder="House name/number and street, P.O. box, company name, c/o">
						<span class="validation-error" v-if="this.validation_errors && this.validation_errors.shipping_address_1">{{ this.validation_errors.shipping_address_1[0] }}</span>
					</p>
					<p>
						<input type="text" name="shipping_address_2" id="shipping_address_2" v-model="shipping_address.address_2" placeholder="Apartment, suite, unit, building, floor, etc. (optional)">
					</p>
					<p>
						<input type="text" name="shipping_address_3" id="shipping_address_3" v-model="shipping_address.address_3" placeholder="(optional)">
					</p>
					<p>
						<label for="shipping_town" class="required">Town</label>
						<input type="text" name="shipping_town" id="shipping_town" v-model="shipping_address.town">
						<span class="validation-error" v-if="this.validation_errors && this.validation_errors.shipping_town">{{ this.validation_errors.shipping_town[0] }}</span>
					</p>
					<p class="half">
						<label for="shipping_county" class="required">County</label>
						<input type="text" name="shipping_county" id="shipping_county" v-model="shipping_address.county">
						<span class="validation-error" v-if="this.validation_errors && this.validation_errors.shipping_county">{{ this.validation_errors.shipping_county[0] }}</span>
					</p>
					<p class="half">
						<label for="shipping_postcode" class="required">Postcode</label>
						<input type="text" name="shipping_postcode" id="shipping_postcode" v-model="shipping_address.postcode" v-on:change="checkDeliveryMethod()" v-on:blur="checkDeliveryMethod()">
						<span class="validation-error" v-if="this.validation_errors && this.validation_errors.shipping_postcode">{{ this.validation_errors.shipping_postcode[0] }}</span>
					</p>
				</div>

				<p class="half">
					<label for="billing_telephone" class="required" data-help="Use mobile number for SMS delivery updates">Telephone</label>
					<input type="text" name="billing_telephone" id="billing_telephone" v-model="billing_address.telephone">
					<span class="validation-error" v-if="this.validation_errors && this.validation_errors.billing_telephone">{{ this.validation_errors.billing_telephone[0] }}</span>
				</p>
				<p class="half" style="align-self: flex-end">
					<label for="billing_email" class="required">Email</label>
					<input type="text" name="billing_email" id="billing_email" v-model="billing_address.email">
					<span class="validation-error" v-if="this.validation_errors && this.validation_errors.billing_email">{{ this.validation_errors.billing_email[0] }}</span>
				</p>
			
				<p>
					<label for="delivery_notes">Delivery Notes</label>
					<textarea name="delivery_notes" id="delivery_notes" v-model="delivery_notes" rows="4" placeholder="Special notes for delivery ONLY" maxlength="120"></textarea>
				</p>
			</div>
		</template>

		<div class="form_style" v-show="show_billing">
			<h2 class="with_line">Billing Details</h2>
			<div class="form_wrap">
				<p class="styled_checkboxes">
					<input type="checkbox" name="diffaddress" id="diffaddress" value="1" v-model="diffaddress">
					<label for="diffaddress"><span>My billing address is different?</span></label>
				</p>

				<div class="different_address" v-show="diffaddress">
					<div class="postcode_lookup">
						<p>
							<label for="billing_lookup_postcode">Enter your postcode to find your address</label>
							<input type="text" name="billing_lookup_postcode" id="billing_lookup_postcode" v-model="billing_lookup_postcode">
							<button type="button" class="button primary" v-on:click="lookupAddress('billing')">Find</button>
						</p>
						<p v-if="billing_lookup_addresses != null">
							<b><i class="fas fa-arrow-alt-down"></i> Select your address from the list below <i class="fas fa-arrow-alt-down"></i></b>
							<span class="select_wrapper" >
								<select class="styled_select" v-model="selected_billing_address">
									<option value="">Select an address</option>
									<option value="Not Listed">My address is not listed</option>
									<template v-for="(address, key) in billing_lookup_addresses">
										<option v-bind:value="address">{{ formatAddress(address.formatted_address) }}</option>
									</template>
								</select>
							</span>
						</p>
					</div>

					<div class="form_wrap" v-show="( default_billing_address != null && Object.keys(default_billing_address).length > 0) || Object.keys(selected_billing_address).length > 0 || show_billing_edit || this.validation_errors">
						<p class="half">
							<label for="billing_first_name" class="required">First Name</label>
							<input type="text" name="billing_first_name" id="billing_first_name" v-model="billing_address.first_name">
							<span class="validation-error" v-if="this.validation_errors && this.validation_errors.billing_first_name">{{ this.validation_errors.billing_first_name[0] }}</span>
						</p>
						<p class="half">
							<label for="billing_last_name" class="required">Last Name</label>
							<input type="text" name="billing_last_name" id="billing_last_name" v-model="billing_address.last_name">
							<span class="validation-error" v-if="this.validation_errors && this.validation_errors.billing_last_name">{{ this.validation_errors.billing_last_name[0] }}</span>
						</p>
						<p v-if="!show_billing_edit" class="address_details"><span v-html="formatted_billing_address"></span><button v-on:click="showBillingEdit()">[edit]</button></p>
						<div class="form_style" v-show="show_billing_edit">
							<p>
								<label for="billing_address_1" class="required">Address</label>
								<input type="text" name="billing_address_1" id="billing_address_1" v-model="billing_address.address_1" placeholder="House name/number and street, P.O. box, company name, c/o">
								<span class="validation-error" v-if="this.validation_errors && this.validation_errors.billing_address_1">{{ this.validation_errors.billing_address_1[0] }}</span>
							</p>
							<p>
								<input type="text" name="billing_address_2" id="billing_address_2" v-model="billing_address.address_2" placeholder="Apartment, suite, unit, building, floor, etc. (optional)">
							</p>
							<p>
								<input type="text" name="billing_address_3" id="billing_address_3" v-model="billing_address.address_3" placeholder="(optional)">
							</p>
							<p>
								<label for="billing_town" class="required">Town</label>
								<input type="text" name="billing_town" id="billing_town" v-model="billing_address.town">
								<span class="validation-error" v-if="this.validation_errors && this.validation_errors.billing_town">{{ this.validation_errors.billing_town[0] }}</span>
							</p>
							<p class="half">
								<label for="billing_county" class="required">County</label>
								<input type="text" name="billing_county" id="billing_county" v-model="billing_address.county">
								<span class="validation-error" v-if="this.validation_errors && this.validation_errors.billing_county">{{ this.validation_errors.billing_county[0] }}</span>
							</p>
							<p class="half">
								<label for="billing_postcode" class="required">Postcode</label>
								<input type="text" name="billing_postcode" id="billing_postcode" v-model="billing_address.postcode" v-on:change="checkDeliveryMethod()" v-on:blur="checkDeliveryMethod()">
								<span class="validation-error" v-if="this.validation_errors && this.validation_errors.billing_postcode">{{ this.validation_errors.billing_postcode[0] }}</span>
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>

		<template v-if="show_account">
			<h2 class="with_line">My Customer Account</h2>
			<div class="form_wrap">
				<template v-if="this.auth">
					<p class="styled_checkboxes">
						<input type="checkbox" name="saveaddresses" id="saveaddresses" value="1">
						<label for="saveaddresses"><span>Save my addresses for next time?</span></label>
					</p>
				</template>
				<template v-else>
					<p>If you would like to set up an account, please enter a password below.</p>
					<p class="half">
						<label for="password">Your password</label>
						<input type="password" name="password" id="password">
						<span class="validation-error" v-if="this.validation_errors && this.validation_errors.password">{{ this.validation_errors.password[0] }}</span>
					</p>
					<p class="half">
						<label for="password_confirmation">Confirm your password</label>
						<input type="password" name="password_confirmation" id="password_confirmation">
					</p>
					<p class="styled_checkboxes" v-if="trade_account_enabled">
						<input type="checkbox" name="trade" id="trade" value="1" v-model="trade">
						<label for="trade"><span>I'd like to make this a Trade account</span></label>
					</p>
					<template  v-if="trade">
						<p>
							<label for="trade_company_name" class="required">What's your company name?</label>
							<input type="text" name="trade_company_name" id="trade_company_name" v-model="trade_company_name">
							<span class="validation-error" v-if="this.validation_errors && this.validation_errors.trade_company_name">{{ this.validation_errors.trade_company_name[0] }}</span>
						</p>
					</template>
				</template>
			</div>
		</template>

		<template v-if="show_summary">
			<h2 class="with_line">My Order Summary</h2>
			<div class="form_wrap">

				<div class="checkout_summary">
					<table>
						<tr>
							<th>
								Item Total
								<br><small>inc VAT</small>
							</th>
							<td>
								{{ format_currency(parseFloat(this.itemTotal.toFixed(2))) }}
							</td>
						</tr>
						<tr>
							<th>
								Delivery
								<template v-if="parseFloat(this.shippingTotal).toFixed(2) > 0">
									<br><small>inc VAT</small>
								</template>
							</th>
							<td>
								
								<template v-if="this.shipping_address.postcode==''">
									Enter your delivery address to show suitable delivery options
								</template>
								<template v-else>
									<template v-if="Object.keys(shipping_services).length == 0">
										Unavailable
									</template>
									<template v-else>
										<ul class="delivery_options">
											<li v-for="service in shipping_services">
												<label>
													<span>
														<input type="radio" :value="service.id" v-model="selected_service_id">
														{{ service.name }}
														<template v-if="service['dates'].length == 1">
															<br>
															<small>
																{{ service['dates'][0][1] }}
																<template v-if="selected_delivery_date_extra">
																	{{ selected_delivery_date_extra }}
																</template>
															</small>
														</template>
													</span>
													<span>
														<template v-if="parseFloat(service.cost)==0">
															Included
														</template>
														<template v-else>
															<b>&pound;{{ addVat(parseFloat(service.cost)).toFixed(2) }} </b>
														</template>
													</span>
												</label>
											</li>
										</ul>
										<template v-if="this.variation_count > this.sample_count && Object.keys(service_dates).length > 1">
											<label>Choose your delivery day</label>
											<span class="select_wrapper" >
												<select class="styled_select" v-model="selected_delivery_date" v-on:change="updateDeliveryDate()">
													<option v-for="date in service_dates" :value="date[0]">{{ date[1] }}</option>
												</select>
											</span>
										</template>
									</template>
								</template>
							</td>
						</tr>
						<tr v-if="this.discountTotal > 0">
							<th>
								Discount
								<br><small>{{ this.discountDescription }}</small>
								<br><small>inc VAT</small>
							</th>
							<td>
								{{ format_currency(addVat(parseFloat(this.discountTotal.toFixed(2)))) }}
							</td>
						</tr>
						<tr>
							<th>
								Total To Pay
								<br><small>includes {{ format_currency(parseFloat(taxTotal.toFixed(2))) }} VAT</small>
							</th>
							<td>
								{{ format_currency(parseFloat(this.orderTotal.toFixed(2))) }}
							</td>
						</tr>
					</table>
				</div>


				<template v-if="!this.auth">
					<p class="styled_checkboxes">
						<input type="checkbox" name="basket_reminder" id="basket_reminder" value="1" v-model="basket_reminder">
						<label for="basket_reminder"><span>If you would like reminders and offers regarding the products you have added to your shopping basket, please tick this box.</span></label>
					</p>
					<p class="styled_checkboxes">
						<input type="checkbox" name="saved_list_reminder" id="saved_list_reminder" value="1" v-model="saved_list_reminder">
						<label for="saved_list_reminder"><span>If you would like reminders and offers regarding the products you have added to your saved list, please tick this box.</span></label>
					</p>
				</template>

			</div>
		</template>
		<div class="form_wrap">
			<p>
				<button type="submit" class="button wide upper solid green arrow" :disabled="submittable == false || Object.keys(shipping_services).length==0" v-on:click.prevent="submitForm()">Continue to Payment</button>
			</p>
		</div>
	</div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
	props: [
		'default_billing_address',
		'default_shipping_address',
		'old_values',
		'auth',
		'preselected_shipping_service_id',
		'preselected_postcode',
		'trade_account_enabled',
		'validation_errors'
	],

	computed: {
		...mapGetters({

		})
	},
  
	data: () => {
		return {
			'billing_address' : {
				address_1: null
			},
			'shipping_address' : {
				address_1: null
			},
			'delivery_notes': '',
			'diffaddress': 0,
			// 'submittable': false,
			'billing_lookup_postcode' : '',
			'billing_lookup_addresses' : null,
			'selected_billing_address' : '',
			'shipping_lookup_postcode' : '',
			'shipping_lookup_addresses' : null,
			'selected_shipping_address' : '',
			'trade' : 0,
			'trade_company_name': '',
			'basket_reminder': 0,
			'saved_list_reminder': 0,
			validationErrors: {
				billing_first_name: null,
				billing_last_name: null,
				billing_address_1: null,
				billing_town: null,
				billing_postcode: null,
				billing_telephone: null,
				billing_email: null,
				shipping_first_name: null,
				shipping_last_name: null,
				shipping_address_1: null,
				shipping_town: null,
				shipping_county: null,
				shipping_postcode: null,
				password: null,
				trade_company_name: null
			},
			itemTotal: 0,
			itemTax: 0,
			shippingTax: 0,
			shippingTotal: 0,
			taxTotal: 0,
			discountTotal: 0,
			orderTotal: 0,
			discountDescription: null,
			discount_code: null,
			service_description : '',
			service_dates : {},
			shipping_services: [],
			selected_service_id: null,
			selected_delivery_date: 'blah',
			variation_count: 0,
			sample_count: 0,

			delivery_method_ok: false,

			show_delivery: true,
			show_delivery_edit: false,
			// show_billing: false,
			show_billing_edit: false,
			// show_account: false,
			// show_summary: false,
		}
	},

	computed: {
		formatted_shipping_address: function () {
			return (this.shipping_address.address_1 ? this.shipping_address.address_1 + '<br>' : '') + (this.shipping_address.address_2 ? this.shipping_address.address_2 + '<br>' : '') + (this.shipping_address.address_3 ? this.shipping_address.address_3 + '<br>' : '') + (this.shipping_address.town ? this.shipping_address.town + '<br>' : '') + (this.shipping_address.county ? this.shipping_address.county + '<br>' : '') + (this.shipping_address.postcode ? this.shipping_address.postcode + '<br>' : '');
		},

		shipping_complete: function () {
			var complete = true;
			if (this.shipping_address.first_name == '' || this.shipping_address.first_name == null) { complete = false; }
			if (this.shipping_address.last_name == '' || this.shipping_address.last_name == null) { complete = false; }
			if (this.shipping_address.address_1 == '' || this.shipping_address.address_1 == null) { complete = false; }
			if (this.shipping_address.town == '' || this.shipping_address.town == null) { complete = false; }
			if (this.shipping_address.county == '' || this.shipping_address.county == null) { complete = false; }
			if (this.shipping_address.postcode == '' || this.shipping_address.postcode == null) { complete = false; }
			if (this.billing_address.telephone == '' || this.billing_address.telephone == null) { complete = false; }
			if (this.billing_address.email == '' || this.billing_address.email == null) { complete = false; }
			return complete;
		},

		formatted_billing_address: function () {
			return (this.billing_address.address_1 ? this.billing_address.address_1 + '<br>' : '') + (this.billing_address.address_2 ? this.billing_address.address_2 + '<br>' : '') + (this.billing_address.address_3 ? this.billing_address.address_3 + '<br>' : '') + (this.billing_address.town ? this.billing_address.town + '<br>' : '') + (this.billing_address.county ? this.billing_address.county + '<br>' : '') + (this.billing_address.postcode ? this.billing_address.postcode + '<br>' : '');
		},

		billing_complete: function () {
			var complete = true;
			if (this.diffaddress == true) {
				if (this.billing_address.first_name == '' || this.billing_address.first_name == null) { complete = false; }
				if (this.billing_address.last_name == '' || this.billing_address.last_name == null) { complete = false; }
				if (this.billing_address.address_1 == '' || this.billing_address.address_1 == null) { complete = false; }
				if (this.billing_address.town == '' || this.billing_address.town == null) { complete = false; }
				if (this.billing_address.county == '' || this.billing_address.county == null) { complete = false; }
				if (this.billing_address.postcode == '' || this.billing_address.postcode == null) { complete = false; }
			} else {
				if (this.shipping_complete == false) { complete = false;  }
			}
			return complete;
		},

		submittable: function () {
			var submittable = true;
			if (this.shipping_complete == false || this.billing_complete == false || this.delivery_method_ok == false) { 
				submittable = false;
			}
			return submittable;
		},

		show_billing: function () {
			return this.shipping_complete;
		},
		show_account: function () {
			return this.shipping_complete && this.billing_complete;
		},
		show_summary: function () {
			return this.shipping_complete && this.billing_complete;
		},
		selected_delivery_date_extra: function () {
			if (this.selected_delivery_date == null || this.selected_service_id == null) { return null; }
			for (var key in this.shipping_services) {
				if (this.shipping_services[key]['id'] == this.selected_service_id) {
					var service = this.shipping_services[key];
					if (service['dates'].length == 1 && service['name'] == 'Standard') {
						return '(estimated)';
					}
				}
			}
			return null;
		}

	},

	watch: {

		'selected_shipping_address': function (address) {
			if (address == 'Not Listed') {
				this.show_delivery_edit = true;
			} else {
				if (address != '') {
					this.populateAddress('shipping', address);
				}
			}
		},

		// 'shipping_complete': function (val) {
		// 	if (val == true) {
		// 		this.show_billing = true;
		// 	} else {
		// 		this.show_billing = false;
		// 		this.show_account = false;
		// 		this.show_summary = false;
		// 	}
		// },

		'selected_billing_address': function (address) {
			if (address == 'Not Listed') {
				this.show_billing_edit = true;
			} else {
				if (address != '') {
					this.populateAddress('billing', address);
				}
			}
		},

		// 'billing_complete': function (val) {
		// 	if (val == true) {
		// 		this.show_account = true;
		// 		this.show_summary = true;
		// 	} else {
		// 		this.show_account = false;
		// 		this.show_summary = false;
		// 	}
		// },
		
		diffaddress: function (val) {
			this.checkDeliveryMethod();
		},
		'billing_address.postcode': function(value){
			if(value !== null) {
				this.billing_address.postcode = this.formatPostcode(value).trim();
			}
		},
		'shipping_address.postcode': function(value){
			if(value !== null) {
				this.shipping_address.postcode = this.formatPostcode(value).trim();
			}
		},


		selected_service_id: function(value) {
			// this.selected_delivery_date = null;
			// loop through the shipping services to find the details that correspond to the id being passed in above
			for (var key in this.shipping_services) {
				if (this.shipping_services[key]['id'] == this.selected_service_id) {
					// got it
					this.service_description = this.shipping_services[key]['description'];
					// if the service allows nominated day then get the dates from the service
					if (this.shipping_services[key]['id']==2 && this.shipping_services[key]['allow_nominated_day']==0) {
						this.service_dates = {};
						this.selected_delivery_date = null;
					}else{
						this.service_dates = this.shipping_services[key]['dates'];
						// if there are dates
						if(Object.keys(this.service_dates).length != 0){
							// and there isn't already one selected then select the first
							if(this.selected_delivery_date==null) {
								this.selected_delivery_date = this.shipping_services[key]['dates'][0][0];
							}else{
							}
						}else{
							this.selected_delivery_date = null;
						}
					}
				}
			}

			this.updateShippingDetails(value, this.selected_delivery_date, this.selected_delivery_date_extra);
		},
	},

	filters:{
		// Ensure the Postcode Is Formatted Correctly
		postcode: function(value) {
			if(value !== null){
				return this.formatPostcode(value).trim();
			}
		}
	},

	mounted() {
		if (this.default_billing_address != null && Object.keys(this.default_billing_address).length > 0) {
			this.billing_address = this.default_billing_address;
		}else{
			this.billing_address.postcode = this.preselected_postcode;
		}
		if (this.default_shipping_address != null && Object.keys(this.default_shipping_address).length > 0) {
			this.shipping_address = this.default_shipping_address;
		}else{
			this.shipping_address.postcode = this.preselected_postcode;
		}
		this.billing_lookup_postcode = this.preselected_postcode;
		this.shipping_lookup_postcode = this.preselected_postcode;

		if (this.old_values != null && Object.keys(this.old_values).length > 0) {
			this.billing_address.first_name = this.old_values.billing_first_name;
			this.billing_address.last_name = this.old_values.billing_last_name;
			this.billing_address.address_1 = this.old_values.billing_address_1;
			this.billing_address.address_2 = this.old_values.billing_address_2;
			this.billing_address.address_3 = this.old_values.billing_address_3;
			this.billing_address.town = this.old_values.billing_town;
			this.billing_address.county = this.old_values.billing_county;
			this.billing_address.postcode = this.old_values.billing_postcode;
			this.billing_address.telephone = this.old_values.billing_telephone;
			this.billing_address.email = this.old_values.billing_email;

			this.diffaddress = this.old_values.diffaddress;

			this.shipping_address.first_name = this.old_values.shipping_first_name;
			this.shipping_address.last_name = this.old_values.shipping_last_name;
			this.shipping_address.address_1 = this.old_values.shipping_address_1;
			this.shipping_address.address_2 = this.old_values.shipping_address_2;
			this.shipping_address.address_3 = this.old_values.shipping_address_3;
			this.shipping_address.town = this.old_values.shipping_town;
			this.shipping_address.county = this.old_values.shipping_county;
			this.shipping_address.postcode = this.old_values.shipping_postcode;

			this.delivery_notes = this.old_values.delivery_notes;

			this.trade = this.old_values.trade;
			this.trade_company_name = this.old_values.trade_company_name;

			if (this.validation_errors &&
				(this.validation_errors.shipping_first_name ||
				this.validation_errors.shipping_last_name ||
				this.validation_errors.shipping_address_1 ||
				this.validation_errors.shipping_town ||
				this.validation_errors.shipping_county ||
				this.validation_errors.shipping_postcode ||
				this.validation_errors.billing_telephone ||
				this.validation_errors.billing_email)
			)
			{
				this.show_delivery_edit = true;
			}

			if (this.validation_errors &&
			   (this.validation_errors.billing_first_name ||
				this.validation_errors.billing_last_name ||
				this.validation_errors.billing_address_1 ||
				this.validation_errors.billing_town ||
				this.validation_errors.billing_county ||
				this.validation_errors.billing_postcode)
			)
			{
				this.show_billing_edit = true;
			}
		}


		this.checkDeliveryMethod();

		this.getShippingServices();
	},

	methods: {
		...mapActions(["addAlert"]),

		showDeliveryEdit: function () {
			this.show_delivery_edit = true;
		},

		showBillingEdit: function () {
			this.show_billing_edit = true;
		},

		checkDeliveryMethod: function() {

			var postcode = this.shipping_address.postcode;
			
			if (postcode != '' && postcode != null) {
				// do the check
				axios.post('/ajax/checkPostcode', {
					postcode: postcode,
					service_id: this.preselected_shipping_service_id
				}).then((response) => {
					if (response.data == 'error') {
						// entered postcode does not use the preselected service
						this.delivery_method_ok = false;
						this.popup(
							'Warning',
							'The delivery postcode you entered is not valid.',
							{
								Continue: {
									text: 'Keep Editing',
								},
							}
						);
					}else if (response.data == 'invalid') {
						this.delivery_method_ok = false;
						// trigger an alert
						this.popup(
							'Warning',
							'The delivery postcode you entered (' + postcode + ') is different to the one used to calculate pricing.<br>Please go back to the shopping basket and update your postcode, or use '+this.preselected_postcode+' as your delivery address.',
							{
								Continue: {
									text: 'Keep Editing',
								},
								Basket: {
									text: 'Go to Basket',
									action: function () {
										window.location.href = '/basket'
									}
								}
							}

						);
					}else{
						// all ok, carry on
						this.getShippingServices();
						this.delivery_method_ok = true;
					}
				});
			}
		},

		popup: function(title, content,buttons) {

			$.alert({
				type: 'red',
				title: title,
				content: content,
				buttons: buttons
			});

		},

		formatPostcode: function(value){
			value = value.toUpperCase();
			if(value !== null){
				var parts = value.match(/^([A-Z]{1,2}\d{1,2}[A-Z]?)\s*(\d[A-Z]{2})$/);
				if(parts !== null){
					parts.shift();
					return parts.join(' ');
				}
				return value;
			}
		},

		submitForm: function() {
			$('#checkout_form').submit();
			return true;
		},


		lookupAddress: function(type) {
			axios.post('/ajax/lookupAddress', {
				postcode: type=='billing' ? this.billing_lookup_postcode : this.shipping_lookup_postcode,
			}).then((response) => {
				if (response.data['Message']) {
					alert(response.data['Message']);
				}else{
					// if(response.data.addresses.length == 0) {
					// 	alert("No Addresses Found");
					// }
					if(type=='billing') {
						this.selected_billing_address = '';
						this.billing_lookup_addresses = response.data.addresses;
						this.billing_lookup_postcode = response.data.postcode;
					}
					if(type=='shipping') {
						this.selected_shipping_address = '';
						this.shipping_lookup_addresses = response.data.addresses;
						this.shipping_lookup_postcode = response.data.postcode;
					}
				}
			});
			
		},

		formatAddress: function(address_array) {
			var returned_address = '';
			for( var i = 0, len = address_array.length; i < len; i++ ) {
				if (address_array[i] != '') {
					returned_address += (i > 0 ? ', ' : '') + address_array[i];
				}
			}
			return returned_address;
		},

		populateAddress: function(type,address) {
			if(type=='billing') {
				this.billing_address.address_1 = address.formatted_address[0];
				this.billing_address.address_2 = address.formatted_address[1];
				this.billing_address.address_3 = address.formatted_address[2];
				this.billing_address.town = address.formatted_address[3];
				this.billing_address.county = address.formatted_address[4];
				this.billing_address.postcode = this.billing_lookup_postcode;
				this.billing_address = Object.assign({}, this.billing_address);

				if (address.formatted_address[0] == "" || address.formatted_address[3] == "" || address.formatted_address[4] == "") {
					this.show_billing_edit = true;
				}
			}
			if (type == 'shipping') {
				this.shipping_address.address_1 = address.line_1;
				this.shipping_address.address_2 = address.line_2;
				this.shipping_address.address_3 = address.line_3 ? address.line_3 : (address.line_4 ? address.line_4 : (address.locality ? address.locality : ''));
				this.shipping_address.town = address.town_or_city;
				this.shipping_address.county = address.county;

				// this.shipping_address.address_1 = address.formatted_address[0];
				// this.shipping_address.address_2 = address.formatted_address[1];
				// this.shipping_address.address_3 = address.formatted_address[2];
				// this.shipping_address.town = address.formatted_address[3];
				// this.shipping_address.county = address.formatted_address[4];
				this.shipping_address.postcode = this.shipping_lookup_postcode;

				this.shipping_address = Object.assign({}, this.shipping_address);

				if (address.formatted_address[0] == "" || address.formatted_address[3] == "" || address.formatted_address[4] == "") {
					this.show_delivery_edit = true;
				}
			}
			this.checkDeliveryMethod();
		},

		numberWithCommas: function(x) {
			return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		},

		format_currency: function(value){
			return "£" + this.numberWithCommas((Math.round( (value + 0.0001) * 100 ) / 100).toFixed(2));
		},

		addVat: function(num) {
			var rate = process.env.MIX_VAT_RATE;
			var multiply_by = 1 + (rate / 100);
			return parseFloat((num * multiply_by).toFixed(2));
		},

		getTotals: function(){
			axios.get('/ajax/getItemTotal')
			.then(response => {
				var itemTotalInc = parseFloat(response.data.inc);
				var itemTotalExc = parseFloat(response.data.exc);
				this.itemTotal = itemTotalInc;

				axios.get('/ajax/getDiscount')
					.then(response => {
					
					this.discountTotal = response.data.value;
					this.discountDescription = response.data.description;

					this.getShippingTotal();

					var subtotal = parseFloat(itemTotalExc.toFixed(2)) + parseFloat(this.shippingTotal.toFixed(2)) - parseFloat(response.data.value.toFixed(2));
					var subtotal_inc = parseFloat(itemTotalInc) + this.addVat(this.shippingTotal) - this.addVat(response.data.value);

					this.taxTotal = subtotal_inc - subtotal;
					this.orderTotal = subtotal_inc;

				})
				.catch(error => {
				});
			})
			.catch(error => {
			});
		},

		getShippingServices: function() {
			axios.get('/ajax/getShippingServices')
				.then(response => {
				this.variation_count = response.data.variation_count;
				this.sample_count = response.data.sample_count;
				this.shipping_services = response.data.services;
				if(response.data.selected_service_id == null) {
					this.selected_service_id = null;
					return;
				}
				this.selected_delivery_date = response.data.selected_delivery_date;
				this.selected_service_id = response.data.selected_service_id;

				for (var key in this.shipping_services) {
					if (this.shipping_services[key]['id'] == this.selected_service_id) {
						this.service_description = this.shipping_services[key]['description'];
						if (this.shipping_services[key]['id']==2 && this.shipping_services[key]['allow_nominated_day']==0) {
							this.service_dates = {};
						}else{
							this.service_dates = this.shipping_services[key]['dates'];
						}
					}
				}

				this.getTotals();
			})
			.catch(error => {
			});
		},

		updateDeliveryDate: function(delivery_date) {
			this.updateShippingDetails(this.selected_service_id, this.selected_delivery_date, this.selected_delivery_date_extra);
		},

		updateShippingDetails: function(shipping_service_id, delivery_date, delivery_date_extra) {
			axios.post('/ajax/setShippingService', {
				shipping_service_id: shipping_service_id,
				delivery_date: delivery_date,
				delivery_date_extra: delivery_date_extra
			})
			.then(response => {
				if (response.data.status=='ok') {
					this.$nextTick(function() {
						this.getShippingServices();
					});

				}else{
					alert(response.data.error);
				}
			})
			.catch(error => {
			});
		},

		getShippingTotal: function () {
			for (var key in this.shipping_services) {
				if (this.shipping_services[key]['id'] == this.selected_service_id) {
					this.shippingTotal = this.shipping_services[key]['cost'];
					this.shipping_products = this.shipping_services[key]['products']
				}
			}
		},



	}
};
function cleanArray(actual) {
  var newArray = new Array();
  for (var i = 0; i < actual.length; i++) {
      newArray.push(actual[i]);
  }
  return newArray;
}
</script>